import { Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { pageTitle } from './usePageTitle';

/** The way home on every screen. */
export default function HomeButton({ className }: { className?: string }) {
  const { pathname, search } = useLocation();
  const atHome = pageTitle(pathname, search) === 'Home';

  return (
    <Button
      asChild
      variant="ghost"
      size="icon"
      className={cn('shrink-0 text-white/90 no-underline hover:bg-white/5 hover:text-white hover:no-underline [&_svg]:size-5', className)}
    >
      <Link to="/" aria-label="Home" title="Home" aria-current={atHome ? 'page' : undefined}>
        <Home aria-hidden />
      </Link>
    </Button>
  );
}
